import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Default as PageIntro } from "../../../partial-templates/page-intro/page-intro.stories";
import { getDummyText } from "../../../../utils";
import { renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/User Management/Registration",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = (args) => {
    return html`
        <div class="ux-t-container">
            ${PageIntro({
                headline: "Registrierung für MyTRUMPF",
                text: "MyTRUMPF richtet sich exklusiv an TRUMPF Kunden und ist bereits für diverse Länder verfügbar. Bitte beachten Sie, dass MyTRUMPF Accounts personenbezogen sind. Jeder Mitarbeiter eines Unternehmens, der auf MyTRUMPF zugreifen möchte, sollte sich deshalb selbst registrieren.",
            })}

            <div class="ux-row">
                <div class="ux-col-12 ux-u-my-xs">
                    <ux-steps>
                        <ux-steps-item
                            number="1"
                            current="${args.step === 1}"
                            done="${args.step > 1}"
                        >
                            E-Mail Adresse
                        </ux-steps-item>
                        <ux-steps-item
                            number="2"
                            current="${args.step === 2}"
                            done="${args.step > 2}"
                        >
                            Persönliche Daten
                        </ux-steps-item>
                        <ux-steps-item
                            number="3"
                            current="${args.step === 3 || args.step === 3.1}"
                            done="${args.step > 3.2}"
                        >
                            Firmendaten
                        </ux-steps-item>
                        <ux-steps-item
                            number="4"
                            current="${args.step === 4}"
                            done="${args.step > 4}"
                        >
                            Passwort
                        </ux-steps-item>
                    </ux-steps>
                </div>
            </div>
            <!-- FORM -->
            <div class="ux-row">
                <div
                    class="ux-col-12 ${args.step === 1
                        ? "ux-u-my-xxxs"
                        : "ux-u-mt-l ux-u-mb-xs"}"
                >
                    ${(function () {
                        if (args.step === 1) return step1();
                        else if (args.step === 2) return step2();
                        else if (args.step === 3) return step3();
                        else if (args.step === 3.1) return step31();
                        else if (args.step === 4) return step4();
                        else if (args.step === "success") return;
                    })()}
                </div>
            </div>
            <!-- BANNER -->
            <div class="ux-row">
                <div class="ux-col-12 ux-u-my-l">TODO</div>
            </div>
        </div>
    `;
};

const TemplateConfirmation = (args) => {
    return html`
        <!-- HEADLINE + TEXT -->
        <div class="ux-row">
            <div class="ux-col-10 ux-u-offset-1 ux-col-md-8 ux-u-offset-md-2 ux-u-mt-m ux-u-text-align--center">
                ${
                    args.step === "success"
                        ? html`
                              <div class="ux-row">
                                  <div
                                      class="ux-col-12 ux-u-text-align--center"
                                  >
                                      <ux-icon
                                          name="checkmark"
                                          weight="normal"
                                          size-s="70"
                                          class="ux-color-success"
                                      ></ux-icon>
                                  </div>
                              </div>
                          `
                        : html``
                }
                <h1 class="ux-text-headline ux-text-headline--giant">
                    ${getDummyText(25)}
                </h1>
                <div class="ux-text-normal ux-u-text-align--center">
                    <p>${getDummyText(400)}</p>
                </div>
                    ${
                        args.step === "declined"
                            ? html`
                                  <div class="ux-u-mt-xs">
                                      <a href="#" class="ux-button">
                                          MEHR ÜBER MYTRUMPF ERFAHREN
                                      </a>
                                  </div>
                              `
                            : html``
                    }
                </div>
            </div>
        </div>
    `;
};

const step1 = () => html`
    <ux-form class="ux-row">
        <div class="ux-col-12 ux-col-lg-8 ux-u-offset-lg-2">
            <form action="#" method="POST">
                <div class="ux-row">
                    <div class="ux-col-12 ux-col-md-8">
                        <p class="ux-text-normal">
                            Ihre Emailadresse wird auch als Ihr Benutzername
                            verwendet.
                        </p>
                    </div>
                    <div class="ux-col-12 ux-col-md-8">
                        <ux-input-field
                            required
                            label="E-Mail Adresse"
                            type="email"
                            id="input"
                            name="input-email"
                            value=""
                            data-validation-required--msg="This field is required"
                            data-validation-invalid--msg="This field is invalid"
                        >
                        </ux-input-field>
                    </div>
                    <div class="ux-col-12 ux-col-md-8">
                        <p class="ux-text-normal">
                            Pflichtfelder sind mit einem * gekennzeichnet.
                        </p>
                    </div>
                    <div class="ux-col-12">
                        <div class="ux-button-group-inverted">
                            <button class="ux-button ux-button--green">
                                Weiter
                            </button>
                            <button class="ux-button">Zurück</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ux-form>
`;

const step2 = () => html`
    <ux-form class="ux-row">
        <div class="ux-col-12 ux-col-lg-8 ux-u-offset-lg-2">
            <div class="ux-row">
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-select
                        required
                        label="Land"
                        name="select-country"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                        full-width
                    >
                        <option value="DE" selected>Deutschland</option>
                        <option value="AT">Österreich</option>
                        <option value="CH">Schweiz</option>
                    </ux-select>
                </div>
            </div>
            <div class="ux-row">
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-select
                        required
                        label="Anrede"
                        name="select-salutation"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                        placeholder="Bitte wählen ..."
                        full-width
                    >
                        <option value="F">Frau</option>
                        <option value="M">Herr</option>
                    </ux-select>
                </div>
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-input-field
                        label="Titel"
                        type="input"
                        name="input-title"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                    >
                    </ux-input-field>
                </div>
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-input-field
                        required
                        label="Vorname"
                        type="input"
                        name="input-name"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                    >
                    </ux-input-field>
                </div>
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-input-field
                        required
                        label="Nachname"
                        type="input"
                        name="input-surname"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                    >
                    </ux-input-field>
                </div>
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-input-field
                        label="Position in der Firma"
                        type="input"
                        name="input-position"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                    >
                    </ux-input-field>
                </div>
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-phone-input
                        required
                        language="de"
                        label="Telefonnummer "
                        country="DE"
                        name="input-phone"
                    ></ux-phone-input>
                </div>
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-select
                        required
                        label="Abteilung"
                        name="input-department"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                        placeholder="Bitte wählen ..."
                        full-width
                    >
                        <option value="">ABC</option>
                        <option value="">XYZ</option>
                    </ux-select>
                </div>
                <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                    <ux-select
                        required
                        label="Grund der Registrierung"
                        name="input-reason"
                        data-validation-required--msg="Dies ist ein Pflichtfeld."
                        data-validation-invalid--msg="Die Eingabe ist ungültig."
                        placeholder="Bitte wählen ..."
                        full-width
                    >
                        <option value="">ABC</option>
                        <option value="">XYZ</option>
                    </ux-select>
                </div>
                <div class="ux-col-12 ux-col-md-8">
                    <p class="ux-text-normal">
                        Pflichtfelder sind mit einem * gekennzeichnet.
                    </p>
                </div>
                <div class="ux-col-12">
                    <div class="ux-button-group-inverted">
                        <button class="ux-button ux-button--green">
                            Weiter
                        </button>
                        <button class="ux-button">Zurück</button>
                    </div>
                </div>
            </div>
        </div>
    </ux-form>
`;

const step31 = () =>
    html`
        <ux-form>
            <div class="ux-row">
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2">
                    <p
                        class="ux-text-normal ux-u-text-align--center ux-u-mb-xs"
                    >
                        ${getDummyText()}
                    </p>
                    <div class="ux-row">
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xxxs"
                        >
                            <div class="ux-label ">
                                Assigned Company name
                            </div>
                            <div class="ux-text-normal">
                                Companyname
                            </div>
                        </div>
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xxxs"
                        >
                            <div class="ux-label ">
                                Address
                            </div>
                            <div class="ux-text-normal">
                                Teststraße</br> 16 70174 Stuttgart</br> Deutschland
                            </div>
                        </div>
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xxxs"
                        >
                            <div class="ux-label ">
                                Customer number                        
                            </div>
                            <div class="ux-text-normal">
                                123456789
                            </div>
                        </div>
                    </div>
                </div>
         
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2">
                    <div class="ux-row ux-u-mt-xs ux-u-d-flex ux-u-flex-jc-between">
                        <div
                            class="ux-col-12 ux-col-md-3 ux-u-mt-xxxs"
                        >
                            <a href="#" class="ux-button ux-button--full-width">
                                Back
                            </a>
                        </div>
                        <div
                            class="ux-col-12 ux-col-md-8"
                        >
                            <div class="ux-row ux-u-d-flex ux-u-flex-dir-md-row-reverse">
                                <div
                                    class="ux-col-12 ux-col-md-6 ux-u-mt-xxxs"
                                >
                                    <a
                                        href="#"
                                        class="ux-button ux-button--primary ux-button--full-width"
                                    >
                                        Accept
                                    </a>
                                </div>
                                <div
                                    class="ux-col-12 ux-col-md-6 ux-u-mt-xxxs"
                                >
                                    <a
                                        href="#"
                                        class="ux-button ux-button--red ux-button--full-width"
                                    >
                                        Decline
                                    </a>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
        </ux-form>
    `;

const step3 = () => html`
    <ux-form class="ux-row">
        <div class="ux-col-12 ux-col-lg-8 ux-u-offset-lg-2">
            <form action="#" method="POST">
                <div class="ux-row">
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-input-field
                            required
                            label="Firmenname"
                            type="text"
                            id="company-name"
                            name="input-company-name"
                            value=""
                            data-validation-required--msg="This field is required"
                            data-validation-invalid--msg="This field is invalid"
                        >
                        </ux-input-field>
                    </div>
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-input-field
                            label="Strasse und Hausnummer"
                            type="text"
                            id="street"
                            name="input-street"
                            value=""
                            data-validation-required--msg="This field is required"
                            data-validation-invalid--msg="This field is invalid"
                        >
                        </ux-input-field>
                    </div>
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-input-field
                            label="Postleitzahl"
                            type="text"
                            id="zip"
                            name="input-zip"
                            value=""
                            data-validation-required--msg="This field is required"
                            data-validation-invalid--msg="This field is invalid"
                        >
                        </ux-input-field>
                    </div>
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-input-field
                            label="Ort"
                            type="text"
                            id="city"
                            name="input-city"
                            value=""
                            data-validation-required--msg="This field is required"
                            data-validation-invalid--msg="This field is invalid"
                        >
                        </ux-input-field>
                    </div>
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-input-field
                            label="Region"
                            type="text"
                            id="region"
                            name="input-region"
                            value=""
                            data-validation-required--msg="This field is required"
                            data-validation-invalid--msg="This field is invalid"
                        >
                        </ux-input-field>
                    </div>
                    <div class="ux-col-12 ux-u-mb-xs">
                        <ux-form-group
                            label="Bitte identifizieren Sie ihe Firma mit..."
                            required
                            data-validation-required--msg="This field is required"
                        >
                            <ux-radio-button
                                name="radio-ident-number"
                                label="Kundennummer"
                                value="company-number"
                            >
                                <ux-icon
                                    name="info"
                                    id="tooltip-company-number"
                                    class="ux-u-ml-xxxs"
                                />
                            </ux-radio-button>

                            <ux-tooltip
                                tooltip-target="ux-icon#tooltip-company-number"
                                align="right"
                            >
                                <p class="ux-text-normal">
                                    Die Kundennummer finden Sie auf dem
                                    Verkaufsbeleg oder ihrem Angebot.<br />
                                    Es handelt sich dabei um eine 6-stellige
                                    Nummer (######)
                                </p>
                            </ux-tooltip>

                            <ux-radio-button
                                name="radio-ident-number"
                                label="Machinenummer"
                                value="machine-number"
                            >
                                <ux-icon
                                    name="info"
                                    id="tooltip-machine-number"
                                    class="ux-u-ml-xxxs"
                                />
                            </ux-radio-button>
                            <ux-tooltip
                                tooltip-target="ux-icon#tooltip-machine-number"
                                align="right"
                            >
                                <p class="ux-text-normal">
                                    Die Seriennummer finden Sie auf dem
                                    Namensschild ihrer Maschine.<br />
                                    Seriennummern können sein:
                                </p>
                                <ul class="ux-list">
                                    <li>10 Ziffern (X####X####)</li>
                                    <li>6 Ziffern (######)</li>
                                </ul>
                            </ux-tooltip>
                        </ux-form-group>
                    </div>
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-input-field
                            type="text"
                            name="serial-number"
                            label="Kunden oder Maschinennummer"
                            required
                            data-validation-required--msg="This field is required"
                            data-validation-regex--expression="^[a-zA-Z0-9]*$"
                            data-validation-regex--msg="This is not a valid Serial number"
                        >
                        </ux-input-field>
                    </div>
                    <div class="ux-col-12 ux-col-md-8">
                        <p class="ux-text-normal">
                            Pflichtfelder sind mit einem * gekennzeichnet.
                        </p>
                    </div>
                    <div class="ux-col-12">
                        <div class="ux-button-group-inverted">
                            <button class="ux-button ux-button--green">
                                Weiter
                            </button>
                            <button class="ux-button">Zurück</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ux-form>
`;

const step4 = () => html`
    <ux-form class="ux-row">
        <div class="ux-col-12 ux-col-lg-8 ux-u-offset-lg-2">
            <form action="#" method="POST">
                <div class="ux-row">
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-password-input
                            required
                            id="passwordvalidate"
                            name="password"
                            label="Passwort"
                            placeholder="Platzhalter"
                            data-validation-required--msg="Bitte überprüfen Sie die Passwortrichtlinien."
                            tooltip-headline="Passwortrichtlinien:"
                            check-length-text="8 Zeichen"
                            check-special-chars-text="1 Sonderzeichen"
                            check-uppercase-text="1 Großbuchstabe"
                            check-lowercase-text="1 Kleinbuchstabe"
                            check-number-text="1 Zahl"
                        ></ux-password-input>
                    </div>
                    <div class="ux-col-12 ux-col-md-6 ux-u-mb-xxs">
                        <ux-password-input
                            required
                            id="password-confirm"
                            name="password-confirm"
                            label="Passwort bestätigen"
                            placeholder="Platzhalter"
                            data-validation-required--msg="Passwort stimmt nicht überein oder entspricht nicht den Passwortrichtlinien."
                            confirm-password-for="passwordvalidate"
                        ></ux-password-input>
                    </div>
                    <div class="ux-col-12 ux-u-mb-xs">
                        <ux-checkbox value="terms" name="terms" required>
                            Hiermit akzeptiere ich die
                            <a href="#">Nutzungsbedingungen</a>.
                        </ux-checkbox>
                    </div>
                    <div class="ux-col-12 ux-u-mb-xs">
                        <ux-checkbox
                            value="privacy-policy"
                            name="privacy-policy"
                            required
                        >
                            Hiermit akzeptiere ich die
                            <a href="#">Datenschutzbestimmungen</a>.
                        </ux-checkbox>
                    </div>
                    <div class="ux-col-12">
                        <div class="ux-button-group-inverted">
                            <button class="ux-button ux-button--green">
                                Weiter
                            </button>
                            <button class="ux-button">Zurück</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ux-form>
`;

const ModalUserInvitationExpiredTemplate = () => html`
    <ux-modal name="user-invitation-expired" opened>
        <ux-modal-content>
            <div class="ux-row">
                <div class="ux-col-12 ux-u-text-align--center">
                    <div class="ux-u-mb-xs">
                        <h2
                            class="ux-u-mb-xxs ux-text-headline ux-text-headline--big"
                        >
                            Einladung abgelaufen
                        </h2>
                        <p
                            class="ux-u-mt-xxxs ux-text-normal ux-text-normal--light-grey"
                        >
                            Ihre Einladung ist älter als 30 Tage und deshalb
                            abgelaufen. Sie können sich erneut eine Einladung
                            zusenden lassen und sich über den neuen Link
                            registrieren. Lorem Ipsum dolor sit amet socectetur
                            adipiscing. Aenen euismod laoreet proin gravida
                            dolore molores.
                        </p>
                    </div>
                    <div class="ux-row">
                        <div class="ux-col-12 ux-col-md-6 ux-u-mt-xxxs">
                            <button
                                type="button"
                                class="ux-button ux-button--full-width"
                                form="user-invitation-expired"
                                data-trigger-modal="close,user-invitation-expired"
                            >
                                Abbrechen
                            </button>
                        </div>
                        <div class="ux-col-12 ux-col-md-6 ux-u-mt-xxxs">
                            <a
                                class="ux-button ux-button--green ux-button--full-width"
                                data-trigger-modal="close,modal-callback"
                                href="#"
                            >
                                Einladung erneut senden
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </ux-modal-content>
    </ux-modal>
`;

const ModalUserInvitationNewTemplate = () => html`
    <ux-modal name="user-invitation-new" opened>
        <ux-modal-content>
            <div class="ux-row">
                <div class="ux-col-12 ux-u-text-align--center">
                    <div class="ux-u-mb-xs">
                        <h2
                            class="ux-u-mb-xxxs ux-text-headline ux-text-headline--big"
                        >
                            Eine neue Einladung wurde an Ihre Emailadresse
                            verschickt!
                        </h2>
                        <p
                            class="ux-u-mt-xxxs ux-text-normal ux-text-normal--light-grey"
                        >
                            Bitte überprüfen Sie Ihr Postfach nach einer neuen
                            Einladung.
                        </p>
                    </div>
                    <div class="ux-button-group ux-button-group--with-spacing">
                        <button
                            type="button"
                            class="ux-button"
                            form="user-invitation-new"
                            data-trigger-modal="close,user-invitation-new"
                        >
                            Schließen
                        </button>
                    </div>
                </div>
            </div>
        </ux-modal-content>
    </ux-modal>
`;

export const Step1 = () => renderPageTemplate(() => Template({ step: 1 }));

export const Step2 = () => renderPageTemplate(() => Template({ step: 2 }));

export const Step3 = () => renderPageTemplate(() => Template({ step: 3 }));

export const Step3CompanyData = () =>
    renderPageTemplate(() => Template({ step: 3.1 }));

export const Step4 = () => renderPageTemplate(() => Template({ step: 4 }));

export const InvitationDeclined = () =>
    renderPageTemplate(() => TemplateConfirmation({ step: "declined" }));

export const SuccessActivation = () =>
    renderPageTemplate(() => TemplateConfirmation({ step: "success" }));

export const InvitationExpired = ModalUserInvitationExpiredTemplate.bind({});

export const InvitationNew = ModalUserInvitationNewTemplate.bind({});
